module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-cove-timber-hayman-1.fd80629c.jpg";